// extracted by mini-css-extract-plugin
export default {"buttonsWrapper":"T1nEv","showMoreButton":"mb_KM"};